// src/pages/Comprobacion.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { motion } from "framer-motion";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../context/authContext";
import logo from "../assets/Logo.png";
import { FaCoins } from "react-icons/fa";
import PopupModal from "../components/PopupModal";
import { updateDoc } from "firebase/firestore";


const Comprobacion = () => {
  const {
    listaClaves,
    Estado,
    addInfoGym,
    logout,
    EstadoLogout,
    gastarTokenEnClase,
  } = useAuth();
  const navigate = useNavigate();

  const [popupType, setPopupType] = useState(null); // "tokens" | "codigo" | "ocupado"
  const [nombresGimnasios, setNombresGimnasios] = useState([]);
  const [codigoIngresado, setCodigoIngresado] = useState({});
  const [tokens, setTokens] = useState(0);

  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const shouldShow = localStorage.getItem("showWelcomePopup");
    if (shouldShow === "true") {
      setShowWelcome(true);
      localStorage.removeItem("showWelcomePopup");
    }
  }, []);

  const frases = [
    "Pedalea en equipo, gana en motivación 💪",
    "El esfuerzo compartido se multiplica 🚴‍♂️🚴‍♀️",
    "Conéctate y supera tus límites juntos 🔥",
  ];
  const frase = frases[Math.floor(Math.random() * frases.length)];

  // Cargar donde estoy

  // 🔹 Guardar el contexto en Firestore → "comprobacion"
  // 🚫 Ya no marcamos activo = true aquí
  useEffect(() => {
    const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
    if (!uid) return;

    const userRef = doc(db, "usuarios", uid);
    updateDoc(userRef, { ultimoContexto: "/comprobacion", activo: false })
      .then(() =>
        console.log("📝 Contexto guardado en Firestore: /comprobacion + activo=false")
      )
      .catch((err) => console.error("❌ Error guardando contexto:", err));
  }, []);



  // 🔹 Cargar gimnasios en tiempo real
  useEffect(() => {
    try {

      const unsubscribe = listaClaves((gimnasios) => {
        const visibles = (gimnasios || []).filter(
          (g) =>
            g?.estado === "abierta" ||
            g?.lobbyActivo === true ||
            g?.alwaysVisibleInComprobacion === true
        );

        setNombresGimnasios(visibles);
      });


      return () => unsubscribe && unsubscribe();
    } catch (error) {
      console.error("❌ Error en listener de gimnasios:", error);
    }
  }, [listaClaves]);



  // 🔹 Cargar tokens del usuario
  useEffect(() => {
    const obtenerTokens = async () => {
      try {
        const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
        if (!uid) return;
        const userRef = doc(db, "usuarios", uid);
        const snap = await getDoc(userRef);
        if (snap.exists()) {
          setTokens(snap.data().tokens || 0);
        }
      } catch (error) {
        console.error("❌ Error al obtener tokens:", error);
      }
    };
    obtenerTokens();
  }, []);

  // 🔹 Al cerrar pestaña en comprobacion → activo = false
  useEffect(() => {
    const handleBeforeUnload = async () => {
      try {
        const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
        if (uid) {
          const userRef = doc(db, "usuarios", uid);
          await updateDoc(userRef, { activo: false });
          console.log("🚪 Usuario marcado inactivo al cerrar desde Comprobacion");
        }
      } catch (err) {
        console.error("❌ Error marcando inactivo en Comprobacion:", err);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const handleCodigoChange = (nombre, value) => {
    setCodigoIngresado((prev) => ({
      ...prev,
      [nombre]: value,
    }));
  };

  const handleVerificarCodigo = async (gimnasio) => {
    document.activeElement?.blur();

    try {
      const codigoIngresadoUsuario =
        codigoIngresado[gimnasio.nombre] || "";

      const uid =
        JSON.parse(localStorage.getItem("usuario"))?.[0];

      if (!uid) return;

      const userRef = doc(db, "usuarios", uid);
      const userSnap = await getDoc(userRef);

      // Comprobar si el usuario ya está dentro de otro gimnasio o canal
      if (userSnap.exists()) {
        const data = userSnap.data();

        if (
          data.nombreGym &&
          data.nombreGym !== gimnasio.nombre
        ) {
          setPopupType("ocupado");
          return;
        }
      }

      // Comprobar código de acceso
      if (codigoIngresadoUsuario !== gimnasio.codigo) {
        setPopupType("codigo");
        return;
      }

      // Guardar gimnasio y clase en localStorage
      localStorage.setItem(
        "gimnasio",
        JSON.stringify(gimnasio.nombre)
      );

      localStorage.setItem(
        "claseId",
        JSON.stringify(gimnasio.claseId || "")
      );

      // Actualizar gimnasio y clase del usuario en Firestore
      await addInfoGym(
        gimnasio.nombre,
        gimnasio.claseId || ""
      );

      // Guardar la fecha del último acceso
      const hoy = new Date()
        .toISOString()
        .split("T")[0];

      await updateDoc(userRef, {
        ultimoAcceso: hoy,
      });

      // Cerrar teclado y restaurar el viewport en móvil
      document.activeElement?.blur();

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });

      // Navegar después de cerrar el teclado
      setTimeout(() => {
        if (gimnasio.nombre === "free") {
          navigate("/homeuser");
        } else {
          navigate("/");
        }
      }, 300);
    } catch (error) {
      console.error(
        "❌ Error al verificar el código:",
        error
      );
    }
  };

  const handlePedalear = async () => {
    try {
      const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
      if (!uid) return;

      const userRef = doc(db, "usuarios", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        if (data.nombreGym && data.nombreGym !== "") {
          setPopupType("ocupado");
          return;
        }
      }

      await addInfoGym("free", "free");
      localStorage.setItem("gimnasio", JSON.stringify("free"));
      localStorage.setItem("claseId", JSON.stringify("free"));
      //await Estado(uid);
      navigate("/homeuser");

    } catch (error) {
      console.error("❌ Error en Solo Pedalear:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await addInfoGym("", "");
      localStorage.removeItem("gimnasio");
      await EstadoLogout();
      localStorage.setItem("logout", Date.now());
      await logout();
    } catch (error) {
      console.error("❌ Error en logout:", error);
    }
  };

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <img
            src={logo}
            alt="RPM Coach"
            className="w-28 h-auto"
          />

          <motion.button
            type="button"
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/comprar-tokens")}
            className="
              flex
              items-center
              gap-2
              px-4
              py-2
              rounded-full
              border
              border-yellow-400/20
              bg-yellow-400/10
              text-base
              font-bold
              text-yellow-300
              shadow-lg
            "
          >
            <FaCoins className="text-yellow-300" />
            <span>{tokens}</span>
            <span className="text-yellow-200">+</span>
          </motion.button>
        </div>

        {/* PRESENTACIÓN */}
        <div className="mb-7">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-green-400">
            Tu próxima sesión
          </p>

          <h1 className="mt-2 text-3xl font-black leading-tight">
            Elige cómo quieres entrenar
          </h1>

          <p className="mt-3 text-sm leading-6 text-gray-400">
            Entra en una clase disponible o empieza ahora mismo en modo libre.
          </p>
        </div>

        {/* RESUMEN MONEDERO */}
        <motion.button
          type="button"
          whileTap={{ scale: 0.98 }}
          onClick={() => navigate("/comprar-tokens")}
          className="
            w-full
            mb-7
            flex
            items-center
            justify-between
            gap-4
            rounded-3xl
            border
            border-yellow-400/20
            bg-gradient-to-r
            from-yellow-500/15
            via-orange-500/10
            to-white/5
            p-4
            text-left
            shadow-xl
          "
        >
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-yellow-400 text-black text-xl">
              <FaCoins />
            </div>

            <div>
              <p className="text-xs uppercase tracking-wider text-yellow-200/70">
                Tu monedero
              </p>

              <p className="mt-1 text-lg font-extrabold text-white">
                {tokens} {tokens === 1 ? "token" : "tokens"}
              </p>
            </div>
          </div>

          <span className="px-3 py-2 rounded-xl bg-yellow-400 text-xs font-extrabold text-black">
            Recargar
          </span>
        </motion.button>

        {/* TÍTULO CANALES */}
        <div className="flex items-end justify-between gap-3 mb-3">
          <div>
            <p className="text-xs uppercase tracking-widest text-gray-500">
              Clases disponibles
            </p>

            <h2 className="mt-1 text-xl font-extrabold">
              Canales activos
            </h2>
          </div>

          <span className="text-xs text-green-400">
            {nombresGimnasios.length} disponibles
          </span>
        </div>

        {/* LISTA DE GIMNASIOS */}
        <div className="space-y-4">
          {nombresGimnasios
            .slice()
            .sort((a, b) => a.prioridad - b.prioridad)
            .map((gimnasio, index) => {
              const esGym = gimnasio.isGym;

              return (
                <motion.div
                  key={gimnasio.id || index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: index * 0.06,
                    duration: 0.35,
                  }}
                  className="
                    relative
                    overflow-hidden
                    rounded-3xl
                    border
                    border-white/10
                    bg-white/[0.07]
                    p-5
                    shadow-xl
                    backdrop-blur-lg
                  "
                >
                  {/* Cabecera tarjeta */}
                  <div className="flex items-start justify-between gap-4 mb-4">
                    <div className="min-w-0">
                      <div
                        className={`
                          inline-flex
                          items-center
                          gap-2
                          rounded-full
                          px-3
                          py-1.5
                          text-[10px]
                          font-black
                          uppercase
                          tracking-wider
                          ${esGym
                            ? "border border-green-400/20 bg-green-500/10 text-green-300"
                            : "border border-yellow-400/20 bg-yellow-500/10 text-yellow-300"
                          }
                        `}
                      >
                        <span
                          className={`w-2 h-2 rounded-full ${esGym ? "bg-green-400" : "bg-yellow-400"
                            }`}
                        />

                        {esGym
                          ? "Gimnasio oficial"
                          : "Canal premium"}
                      </div>

                      <h3 className="mt-3 text-xl font-extrabold text-white truncate">
                        {gimnasio.nombre}
                      </h3>

                      <p className="mt-1 text-sm text-gray-400">
                        {esGym
                          ? "Acceso incluido. No consume tokens."
                          : "Accede al directo por 1 token."}
                      </p>
                    </div>

                    <div
                      className={`
                        w-12
                        h-12
                        shrink-0
                        flex
                        items-center
                        justify-center
                        rounded-2xl
                        text-2xl
                        ${esGym
                          ? "bg-green-500/10"
                          : "bg-yellow-500/10"
                        }
                      `}
                    >
                      {esGym ? "🏋️" : "📺"}
                    </div>
                  </div>

                  {/* Código + entrar */}
                  <div className="flex gap-2">
                    <input
                      type="text"
                      autoCapitalize="characters"
                      placeholder="Código de acceso"
                      value={
                        codigoIngresado[gimnasio.nombre] || ""
                      }
                      onChange={(e) =>
                        handleCodigoChange(
                          gimnasio.nombre,
                          e.target.value.toUpperCase()
                        )
                      }
                      className="
                        min-w-0
                        flex-1
                        rounded-2xl
                        border
                        border-white/10
                        bg-black/20
                        px-4
                        py-3
                        text-base
                        font-semibold
                        uppercase
                        tracking-wider
                        text-white
                        placeholder-gray-500
                        outline-none
                        transition
                        focus:border-green-400/50
                      "
                    />

                    <motion.button
                      type="button"
                      whileTap={{ scale: 0.95 }}
                      onClick={() =>
                        handleVerificarCodigo(gimnasio)
                      }
                      className={`
                        shrink-0
                        rounded-2xl
                        px-5
                        py-3
                        text-sm
                        font-extrabold
                        shadow-lg
                        ${esGym
                          ? "bg-gradient-to-r from-green-400 to-emerald-600 text-white"
                          : "bg-gradient-to-r from-yellow-400 to-orange-500 text-black"
                        }
                      `}
                    >
                      Entrar
                    </motion.button>
                  </div>
                </motion.div>
              );
            })}
        </div>

        {/* SIN CANALES */}
        {nombresGimnasios.length === 0 && (
          <div className="rounded-3xl border border-white/10 bg-white/5 p-6 text-center shadow-lg">
            <div className="mx-auto w-12 h-12 flex items-center justify-center rounded-2xl bg-white/10 text-2xl">
              🚴
            </div>

            <h3 className="mt-4 font-extrabold text-white">
              No hay clases activas
            </h3>

            <p className="mt-2 text-sm leading-6 text-gray-400">
              Puedes empezar en modo libre mientras aparece una nueva clase.
            </p>
          </div>
        )}

        {/* MODO LIBRE */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          className="
            relative
            overflow-hidden
            mt-7
            rounded-3xl
            border
            border-blue-400/20
            bg-gradient-to-br
            from-blue-500/15
            via-indigo-500/10
            to-white/5
            p-5
            shadow-xl
          "
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-widest text-blue-300">
                Sin códigos
              </p>

              <h2 className="mt-1 text-xl font-extrabold">
                Entrena en modo libre
              </h2>

              <p className="mt-2 text-sm leading-6 text-gray-300">
                Empieza ahora, mide tus RPM y guarda tu entrenamiento.
              </p>
            </div>

            <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-2xl bg-blue-500/20 text-2xl">
              🚴‍♂️
            </div>
          </div>

          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={handlePedalear}
            className="
              w-full
              mt-5
              py-4
              rounded-2xl
              bg-gradient-to-r
              from-blue-400
              to-indigo-600
              text-white
              font-extrabold
              shadow-xl
            "
          >
            Empezar a pedalear
          </motion.button>
        </motion.div>

        {/* ACCIONES SECUNDARIAS */}
        <div className="grid grid-cols-2 gap-3 mt-5">
          <motion.button
            type="button"
            whileTap={{ scale: 0.97 }}

            onClick={() =>
              navigate("/ranking", {
                state: { tipoRanking: "global" },
              })
            }

            className="
              py-4
              rounded-2xl
              border
              border-blue-400/20
              bg-blue-500/10
              text-blue-300
              font-bold
              shadow-lg
            "
          >
            🏆 Ranking
          </motion.button>

          <motion.button
            type="button"
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/historial")}
            className="
              py-4
              rounded-2xl
              border
              border-purple-400/20
              bg-purple-500/10
              text-purple-300
              font-bold
              shadow-lg
            "
          >
            📊 Historial
          </motion.button>
        </div>

        {/* CERRAR SESIÓN */}
        <div className="mt-6 rounded-3xl border border-white/10 bg-white/5 p-4">
          <p className="mb-2 text-xs uppercase tracking-widest text-gray-500">
            Cuenta
          </p>

          <button
            type="button"
            onClick={handleLogout}
            className="
              w-full
              py-3
              rounded-xl
              border
              border-red-400/10
              bg-red-500/5
              text-sm
              font-semibold
              text-red-400
            "
          >
            Cerrar sesión
          </button>
        </div>

        {/* POPUPS */}
        <PopupModal
          show={popupType === "tokens"}
          onClose={() => setPopupType(null)}
          type="error"
          title="❌ No tienes tokens disponibles"
          message="Consigue más tokens para poder unirte a una clase."
        />

        <PopupModal
          show={popupType === "codigo"}
          onClose={() => setPopupType(null)}
          type="error"
          title="❌ Código incorrecto"
          message="El código ingresado no coincide con el gimnasio."
        />

        <PopupModal
          show={popupType === "ocupado"}
          onClose={() => setPopupType(null)}
          type="error"
          title="🚫 Ya estás en otra clase"
          message="No puedes unirte a otra clase hasta salir primero de tu clase actual."
        />

        <PopupModal
          show={showWelcome}
          onClose={() => setShowWelcome(false)}
          type="success"
          title="🎉 ¡Bienvenido!"
          message="Te regalamos 3 tokens para que empieces a entrenar al máximo 🚴‍♂️🔥"
        />

        {/* FRASE */}
        <p className="mt-8 text-center text-xs italic text-gray-500">
          {frase}
        </p>
      </div>
    </div>
  );
};

export default Comprobacion;